export default __webpack_public_path__ + "static/media/cross.9972d8af.svg";